import React from 'react';
import { Link } from 'react-router-dom';
import './DmcaPage.css';

const DmcaPage = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>DMCA Copyright Policy</h1>
        <p className="legal-meta">Effective Date: June 13, 2026 &middot; Version 1.0</p>

        <section>
          <p>
            QorVertex LLC ("AmpNebula") respects the intellectual property rights of others and complies
            with the Digital Millennium Copyright Act (DMCA), 17 U.S.C. § 512. If you believe that
            content on AmpNebula infringes your copyright, follow the procedure below.
          </p>
        </section>

        <section>
          <h2>1. Designated Copyright Agent</h2>
          <p>Our designated agent to receive DMCA notices is:</p>
          <p>
            <strong>QorVertex LLC (AmpNebula)</strong><br />
            Email: <a href="mailto:dmca@ampnebula.com">dmca@ampnebula.com</a>
          </p>
          <p>
            This agent is registered with the U.S. Copyright Office as required by
            17 U.S.C. § 512(c)(2). Registration number: <strong>DMCA-1074212</strong>.
          </p>
        </section>

        <section>
          <h2>2. How to Submit a Takedown Notice</h2>
          <p>
            To submit a valid DMCA takedown notice, send a written communication to our designated
            agent that includes <strong>all</strong> of the following (17 U.S.C. § 512(c)(3)):
          </p>
          <ol>
            <li>
              <strong>Identification of the copyrighted work</strong> &mdash; Describe the copyrighted
              work you claim has been infringed, or provide a representative list if multiple works
              are at issue.
            </li>
            <li>
              <strong>Identification of the infringing material</strong> &mdash; Provide the specific
              URL(s) on AmpNebula where the allegedly infringing content appears, with enough detail
              for us to locate it.
            </li>
            <li>
              <strong>Your contact information</strong> &mdash; Your full name, mailing address,
              telephone number, and email address.
            </li>
            <li>
              <strong>Good faith statement</strong> &mdash; A statement that you have a good faith
              belief that use of the material in the manner complained of is not authorized by the
              copyright owner, its agent, or the law.
            </li>
            <li>
              <strong>Accuracy statement</strong> &mdash; A statement, made under penalty of perjury,
              that the information in your notice is accurate and that you are the copyright owner or
              are authorized to act on the copyright owner's behalf.
            </li>
            <li>
              <strong>Signature</strong> &mdash; A physical or electronic signature of the copyright
              owner or a person authorized to act on their behalf.
            </li>
          </ol>
          <p>
            Send your notice to{' '}
            <a href="mailto:dmca@ampnebula.com">dmca@ampnebula.com</a>. We will process valid notices
            promptly and, where appropriate, remove or disable access to the allegedly infringing content.
          </p>
        </section>

        <section>
          <h2>3. Counter-Notice</h2>
          <p>
            If your content was removed in response to a DMCA notice and you believe the removal was
            in error or based on misidentification, you may submit a counter-notice to our designated
            agent at <a href="mailto:dmca@ampnebula.com">dmca@ampnebula.com</a> containing
            (17 U.S.C. § 512(g)(3)):
          </p>
          <ol>
            <li>Your physical or electronic signature.</li>
            <li>
              Identification of the material that was removed and the location where it appeared
              before removal.
            </li>
            <li>
              A statement under penalty of perjury that you have a good faith belief the material was
              removed or disabled as a result of mistake or misidentification.
            </li>
            <li>
              Your name, address, and telephone number, and a statement that you consent to the
              jurisdiction of the federal district court for the district where your address is located
              (or, if outside the U.S., any judicial district in which AmpNebula may be found), and
              that you will accept service of process from the person who provided the original notice.
            </li>
          </ol>
          <p>
            Upon receipt of a valid counter-notice, we will forward it to the original complainant.
            If the complainant does not file a court action within 10&ndash;14 business days, the
            removed content may be restored.
          </p>
        </section>

        <section>
          <h2>4. Repeat Infringer Policy</h2>
          <p>
            AmpNebula will terminate the accounts of users who are determined to be repeat infringers
            of intellectual property rights, in accordance with 17 U.S.C. § 512(i).
          </p>
        </section>

        <section>
          <h2>5. Misrepresentation Warning</h2>
          <p>
            Under 17 U.S.C. § 512(f), any person who knowingly and materially misrepresents that
            material is infringing, or that material was removed by mistake or misidentification, may
            be liable for damages, costs, and attorneys' fees. If you are uncertain whether content
            infringes your copyright, please consult a qualified legal professional before submitting
            a notice.
          </p>
        </section>

        <div className="legal-nav">
          <Link to="/terms">Terms of Service</Link>
          {' · '}
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default DmcaPage;
